import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import dashboardActionCreators from '../../store/dashboard/action-creators';
import MgtMetricTiles from './MgtMetricTiles';
import OitProgressChart from './OitProgressChart';
import LoadingOverlay from '../../../shared/components/LoadingOverlay';

class DepadminDashboard extends Component {
  componentDidMount() {
    this.props.fetchOutstandingForms();
    this.props.fetchActiveFtos();
    this.props.fetchActiveOits();
    this.props.fetchOitsStatsRemedial();
    this.props.fetchRiskAlertStats();
  }

  get isLoading() {
    return (
      this.props.isLoading.includes('fetchOutstandingForms') ||
      this.props.isLoading.includes('fetchActiveFtos') ||
      this.props.isLoading.includes('fetchActiveOits') ||
      this.props.isLoading.includes('fetchRiskAlertStats') ||
      this.props.isLoading.includes('fetchOitsStatsRemedial')
    );
  }

  render() {
    return (
      <Fragment>
        <div className="app-content-header">
          <h4 className="title">Dashboard</h4>
          <p className="sub-title text-muted">Department admin</p>
        </div>
        <div className="app-content dashboard">
          <LoadingOverlay isLoading={this.isLoading}>
            <MgtMetricTiles />
            <OitProgressChart />
          </LoadingOverlay>
        </div>
      </Fragment>
    );
  }
}

// ----------------------
// Redux Mappings
// ----------------------

const mapStateToProps = (state) => {
  return {
    isLoading: state.dashboard.isLoading,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchOutstandingForms: () => {
      return dispatch(dashboardActionCreators.fetchOutstandingForms());
    },
    fetchActiveFtos: () => {
      return dispatch(dashboardActionCreators.fetchActiveFtos());
    },
    fetchActiveOits: () => {
      return dispatch(dashboardActionCreators.fetchActiveOits());
    },
    fetchOitsStatsRemedial: () => {
      return dispatch(dashboardActionCreators.fetchOitsStatsRemedial());
    },
    fetchRiskAlertStats: () => {
      return dispatch(dashboardActionCreators.fetchRiskAlertStats());
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DepadminDashboard);
